import React from 'react';
import { Route, Routes } from 'react-router-dom';

import SignUp from '@pages/sign_up';

export default function UserRoutes() {
  return (
    <Routes>
      <Route path='/users/sign_up' element={<SignUp />} />
    </Routes>
  );
}
